import Sidebar from "../components/Sidebar";

export default function ApiInfoPage() {
  return (
    <div data-testid="api-info-page" className="min-h-screen bg-[#000000] flex">
      <Sidebar activeMenu="api" />

      <main className="flex-1 md:ml-56 pb-20 md:pb-0">
        <header className="h-14 md:h-16 border-b border-[#222222] flex items-center px-4 md:px-8 bg-[#0A0A0A]">
          <h1 className="text-lg md:text-xl font-bold text-[#EDEDED] font-heading">
            Documentação
          </h1>
        </header>

        <div className="p-4 md:p-8 flex items-center justify-center min-h-[60vh]">
          <div className="bg-[#0A0A0A] border border-[#222222] p-10 md:p-16 text-center max-w-md w-full">
            <h2 className="text-xl font-bold text-[#EDEDED] font-heading mb-3">
              Em Breve
            </h2>
            <p className="text-[#555555] font-mono text-sm leading-relaxed">
              Sistema de documentação Swagger em desenvolvimento.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
